import { Group } from '@mantine/core';
import type { TeamOut } from '@repo/api-codegen';
import { useApiListTeamsV2 } from '@repo/api-codegen/v2';
import { Navigate } from 'react-router';
import { EmptyState } from '../../components/EmptyState';
import type { LEGACY_NON_TEAM_PATHS } from './constants';

function LegacyNonTeamPage({
	oldPath,
}: {
	oldPath: (typeof LEGACY_NON_TEAM_PATHS)[number];
}) {
	const { data: teams } = useApiListTeamsV2({
		queryParams: {
			only_joined: true,
		},
	});

	if (!teams) {
		return null;
	}

	// Grab the first team user has joined, favor default team
	const team: TeamOut | undefined = teams.sort(
		(t1: TeamOut, t2: TeamOut) => +t2.is_default_team - +t1.is_default_team
	)[0];

	if (!team) {
		return (
			<Group w="100%" mih="50vh" position="center">
				<EmptyState
					imgSrc="/images/empty-state/alert.svg"
					title="Not found"
					description="This page no longer exist."
					includeGoBack={false}
					size="sm"
				/>
			</Group>
		);
	}

	return <Navigate to={`/teams/${team.id}${oldPath}`} replace />;
}

export default LegacyNonTeamPage;
